module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00055.7820e3b2.jpg";